import React from "react";
import { graphql } from "react-apollo";
import { compose } from "recompose";
import { defineMessages, useIntl } from "react-intl";
import Price from "theme/components/atoms/Typography/Price";
import ConvertedPrice from "theme/components/atoms/Typography/Price/ConvertedPrice";
import CustomerBillingCountryQuery from "theme/components/atoms/Typography/Price/CustomerBillingCountryQuery.gql";

const messages = defineMessages({
  discount: {
    id: "modules.Cart.MiniCart.MiniCartContent.discount",
    defaultMessage: "Discount",
  },
  totalExclTax: {
    id: "modules.Cart.MiniCart.MiniCartContent.totalExclTax",
    defaultMessage: "Total Excl. VAT",
  },
  shipping: {
    id: "modules.Cart.MiniCart.MiniCartContent.shipping",
    defaultMessage: "Shipping",
  },
  subtotalExclTax: {
    id: "modules.Cart.MiniCart.MiniCartContent.subtotalExclTax",
    defaultMessage: "Subtotal Excl. VAT",
  },
});

const MiniCartTotal = ({ cart, customerBillingCountry }) => {
  const intl = useIntl();
  const cartCountry = cart?.currentBillingAddress?.country_id;
  const customerCountry =
    customerBillingCountry?.me?.default_billing?.country_id;
  const isCanadianCustomer = (cartCountry || customerCountry) === "CA";
  return (
    <div className="mini-cart-total">
      <div className="mini-cart-total__subtotal mini-cart-total__row">
        <span className="mini-cart-total__subtotal-label">
          {intl.formatMessage(messages.subtotalExclTax)}
        </span>
        <span className="mini-cart-total__main-value">
          <Price price={cart.totals.subtotalExclTax} />{" "}
          {isCanadianCustomer ? (
            <ConvertedPrice price={cart.totals.subtotalExclTax} />
          ) : (
            ""
          )}
        </span>
      </div>

      <div className="mini-cart-total__shipping mini-cart-total__row">
        <span className="mini-cart-total__shipping-label">
          {intl.formatMessage(messages.shipping)}
        </span>
        <span className="mini-cart-total__shipping-value">
          <Price price={cart.totals.shippingPriceExclTax} />{" "}
          {isCanadianCustomer ? (
            <ConvertedPrice price={cart.totals.shippingPriceExclTax} />
          ) : (
            ""
          )}
        </span>
      </div>

      {cart.totals.discount.value.amount !== 0 && (
        <div className="mini-cart-total__discount mini-cart-total__row">
          <span className="mini-cart-total__discount-label">
            {intl.formatMessage(messages.discount)}
          </span>
          <span className="mini-cart-total__discount-value">
            <Price price={cart.totals.discount} />
          </span>
        </div>
      )}

      <hr className="mini-cart-total__separator" />

      <div className="mini-cart-total__main mini-cart-total__row">
        <span className="mini-cart-total__main-label">
          {intl.formatMessage(messages.totalExclTax)}
        </span>
        <span className="mini-cart-total__main-value">
          <Price price={cart.totals.totalExclTax} />{" "}
          {isCanadianCustomer ? (
            <ConvertedPrice price={cart.totals.totalExclTax} />
          ) : (
            ""
          )}
        </span>
      </div>
    </div>
  );
};

export default compose(
  graphql(CustomerBillingCountryQuery, { name: "customerBillingCountry" })
)(MiniCartTotal);
